import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCopyright: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCopyright"><Path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM9 12C9 10.3431 10.3431 9 12 9C13.1092 9 14.079 9.60141 14.5993 10.5007L16.3305 9.49927C15.4675 8.00738 13.852 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C13.852 17 15.4675 15.9926 16.3305 14.5007L14.5993 13.4993C14.079 14.3986 13.1092 15 12 15C10.3431 15 9 13.6569 9 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCopyright;
